export default __webpack_public_path__ + "static/pic2-6c7ffe2f075a55bee2517c874b146861.png";